import { useQuery } from '@tanstack/react-query';
import { fetchTravelTime } from "./endpoints";
export const useTravelTime = (workOrderId) => {
    const { data: travelTime, isLoading, isFetching, isError, } = useQuery({
        queryKey: ['travelTime', workOrderId],
        queryFn: () => fetchTravelTime(workOrderId),
        enabled: !!workOrderId,
    });
    return {
        travelTime,
        isLoading,
        isFetching,
        isError,
    };
};
